// extracted by mini-css-extract-plugin
module.exports = {"container":"Gosuslugy_container__1VrH6","filters":"Gosuslugy_filters__157n6"};